/* eslint-disable import/no-anonymous-default-export */

export default (newInvestment = [], action) => {
  switch (action.type) {
    case "NEW_INVESTMENTS":
      return action.payload;
    case "CREATE_NEW_INVESTMENT":
      return [...newInvestment, action.payload];
    case "APPROVE_NEW_INVESTMENT":
      return newInvestment.filter((data) => data._id !== action.payload);
    case "EDIT_NEW_INVESTMENT":
      const updated = action.payload?.data || action.payload;
      return newInvestment.map((a) =>
        (a?._id || a?.id) === (updated?._id || updated?.id) ? updated : a,
      );

    case "DELETE_NEW_INVESTMENT":
      return newInvestment.filter((data) => data._id !== action.payload);
    default:
      return newInvestment;
  }
};
